export const setInspectionItems = (items) => {
    return {
        type: 'CHECKLIST_SET_INSPECTION_ITEMS',
        payload: {
            items,
        },
    };
};

export const setInspectionSearchValue = (value) => {
    return {
        type: 'CHECKLIST_SET_INSPECTION_SEARCH_VALUE',
        payload: {
            value,
        },
    };
};

export const setInspectionSelectedItem = (data) => {
    return {
        type: 'CHECKLIST_SET_INSPECTION_SELECTED_ITEM',
        payload: {
            data,
        },
    };
};

export const setInspectionSortSelectedItem = (data) => {
    return {
        type: 'CHECKLIST_SET_INSPECTION_SORT_SELECTED_ITEM',
        payload: {
            data,
        },
    };
};

export const setInspectionSelectedFilters = (data) => {
    return {
        type: 'CHECKLIST_SET_INSPECTION_SELECTED_FILTERS',
        payload: {
            data,
        },
    };
};

export const resetInspectionSelectedFilters = () => {
    return {
        type: 'CHECKLIST_RESET_INSPECTION_SELECTED_FILTERS',
    };
};

export const setInspectionTemplateItems = (items) => {
    return {
        type: 'CHECKLIST_SET_INSPECTION_TEMPLATE_ITEMS',
        payload: {
            items,
        },
    };
};

export const setInspectionEmployeeItems = (items) => {
    return {
        type: 'CHECKLIST_SET_INSPECTION_EMPLOYEE_ITEMS',
        payload: {
            items,
        },
    };
};

export const setInspectionTransportItems = (items) => {
    return {
        type: 'CHECKLIST_SET_INSPECTION_TRANSPORT_ITEMS',
        payload: {
            items,
        },
    };
};

export const setInspectionTransportGroupItems = (items) => {
    return {
        type: 'CHECKLIST_SET_INSPECTION_TRANSPORT_GROUP_ITEMS',
        payload: {
            items,
        },
    };
};

export const setInspectionAutocolonItems = (items) => {
    return {
        type: 'CHECKLIST_SET_INSPECTION_AUTOCOLON_ITEMS',
        payload: {
            items,
        },
    };
};

export const setTemplateItems = (items) => {
    return {
        type: 'CHECKLIST_SET_TEMPLATE_ITEMS',
        payload: {
            items,
        },
    };
};

export const setTemplateSelectedItem = (data) => {
    return {
        type: 'CHECKLIST_SET_TEMPLATE_SELECTED_ITEM',
        payload: {
            data,
        },
    };
};

export const setTemplateSearchValue = (value) => {
    return {
        type: 'CHECKLIST_SET_TEMPLATE_SEARCH_VALUE',
        payload: {
            value,
        },
    };
};

export const setTemplateSortSelectedItem = (data) => {
    return {
        type: 'CHECKLIST_SET_TEMPLATE_SORT_SELECTED_ITEM',
        payload: {
            data,
        },
    };
};

export const addTemplateListItem = (data) => {
    return {
        type: 'CHECKLIST_ADD_TEMPLATE_LIST_ITEM',
        payload: {
            data,
        },
    };
};

export const updateTemplateListItem = (data) => {
    return {
        type: 'CHECKLIST_UPDATE_TEMPLATE_LIST_ITEM',
        payload: {
            data,
        },
    };
};

export const setTemplateGroupItems = (items) => {
    return {
        type: 'CHECKLIST_SET_TEMPLATE_GROUP_ITEMS',
        payload: {
            items,
        },
    };
};

export const setTemplateHistoryItems = (items) => {
    return {
        type: 'CHECKLIST_SET_TEMPLATE_HISTORY_ITEMS',
        payload: {
            items,
        },
    };
};

export const setGroupItems = (items) => {
    return {
        type: 'CHECKLIST_SET_GROUP_ITEMS',
        payload: {
            items,
        },
    };
};

export const addGroupListItem = (data) => {
    return {
        type: 'CHECKLIST_ADD_GROUP_ITEM',
        payload: {
            data,
        },
    };
};

export const updateGroupListItem = (data) => {
    return {
        type: 'CHECKLIST_UPDATE_GROUP_ITEM',
        payload: {
            data,
        },
    };
};

export const setGroupSelectedItem = (data) => {
    return {
        type: 'CHECKLIST_SET_GROUP_SELECTED_ITEM',
        payload: {
            data,
        },
    };
};

export const setGroupSearchValue = (value) => {
    return {
        type: 'CHECKLIST_SET_GROUP_SEARCH_VALUE',
        payload: {
            value,
        },
    };
};

export const setGroupSelectedItemData = (items) => {
    return {
        type: 'CHECKLIST_SET_GROUP_SELECTED_ITEM_DATA',
        payload: {
            items,
        },
    };
};

export const setGroupSelectedItemTransport = (id) => {
    return {
        type: 'CHECKLIST_SET_GROUP_SELECTED_ITEM_TRANSPORT',
        payload: {
            id,
        },
    };
};

export const setGroupSelectedItemsTransport = (bool) => {
    return {
        type: 'CHECKLIST_SET_GROUP_SELECTED_ITEMS_TRANSPORT',
        payload: {
            bool,
        },
    };
};
export const setTemplateAutocolonsItems = (items) => {
    return {
        type: 'CHECKLIST_SET_TEMPLATE_AUTOCOLONS_ITEMS',
        payload: {
            items,
        },
    };
};
